import { Link } from 'react-router-dom';
import { useT } from '@/i18n/I18nProvider';
import { cn } from '@/shared/lib/cn';
import { useNavBadges } from './useNavBadges';

const CAPSULE =
  'hidden items-center gap-2 rounded-full border py-1.5 pl-2.5 pr-3.5 text-[13px] transition-colors focus-visible:ring-2 md:inline-flex whitespace-nowrap';

/**
 * Kapsuły „N do zatwierdzenia” (akceptacje czekające na zalogowanego) i „N do poprawy” (moje wnioski zwrócone przez działy) — jak w ZUR OPS.
 * Każda ukryta, gdy 0.
 */
export function TopbarApprovals() {
  const t = useT();
  const { workflowPending, workflowReturned } = useNavBadges();
  return (
    <>
      {workflowPending > 0 && (
        <Link to="/workflow?tab=pending" className={cn(CAPSULE, 'border-warning/40 bg-warning/10 hover:bg-warning/20 focus-visible:ring-warning/40')}>
          <span className="size-2 rounded-full bg-warning shadow-[0_0_8px_hsl(var(--warning))]" aria-hidden />
          <span className="font-bold tabular text-warning">{workflowPending}</span>
          <span className="text-sidebar-foreground">{t('topbar.pendingApprovals')}</span>
        </Link>
      )}
      {workflowReturned > 0 && (
        <Link to="/workflow?tab=returned" className={cn(CAPSULE, 'border-violet/40 bg-violet/10 hover:bg-violet/20 focus-visible:ring-violet/40')}>
          <span className="size-2 rounded-full bg-violet shadow-[0_0_8px_hsl(var(--violet))]" aria-hidden />
          <span className="font-bold tabular text-violet">{workflowReturned}</span>
          <span className="text-sidebar-foreground">{t('topbar.returnedApprovals')}</span>
        </Link>
      )}
    </>
  );
}
